<template>
  <div class="block-head">
    <bimContainer>
      <bimCol cols=12 md=10 class="mx-auto">
        <div class="d-flex flex-wrap">
          <bim-col cols=12 xl=8>
            <bim-text adaptive type=h1 class="block-head__title" bold>Соберите книгу конъюктурного анализа в пару кликов</bim-text>
            <bim-text adaptive type=accent class="my-11">Искусственный интеллект в помощь сметчику</bim-text>
            <a class="d-block" href="#download-documentation">
              <bim-button label="Загрузить документацию" class="block-head__button" />
            </a>
          </bim-col>
          <bim-col cols=12 xl=4 class="d-none d-sm-flex justify-end ">
            <img alt="" :src="img_catalog + 's-1.svg'" />
          </bim-col>
        </div>

        <bim-col class="advantages d-flex flex-wrap mt-11">
          <div
            v-for="advantage of advantages"
            :key="advantage.text"
            class="advantages__item d-flex"
          >
            <img alt="" :src="advantage.icon" class="advantages__item-icon" :width="advantage.icon_width" :height="advantage.icon_height" />
            <bim-text adaptive bold type=main class="advantages__item-text ml-6">{{ advantage.text }}</bim-text>
          </div>
        </bim-col>
      </bimCol>
    </bimContainer>
  </div>
</template>

<script>
import bimContainer from "@bimlib/components/bimContainer"
import bimCol from "@bimlib/components/bimCol"
import bimButton from "@bimlib/components/bimButton"
const img_catalog = "/dist/assets/front_white/img/landing_estimate/"
export default {
  name: "",
  components: {
    bimContainer,
    bimCol,
    bimButton,
  },
  data() {
    return {
      img_catalog,
      advantages: [
        {
          icon: img_catalog + "r-1.svg",
          icon_width: "24px",
          icon_height: "24px",
          text: "Всего 30 секунд на анализ позиции ресурса",
        },
        {
          icon: img_catalog + "r-3.svg",
          icon_width: "24px",
          icon_height: "18px",
          text: "Актуальные цены на момент обновления",
        },
        {
          icon: img_catalog + "r-5.svg",
          icon_width: "22px",
          icon_height: "22px",
          text: "QR-ссылки на оферты от поставщиков",
        },
        {
          icon: img_catalog + "r-2.svg",
          icon_width: "24px",
          icon_height: "24px",
          text: "Работаем на XML-сметах, сформированных по ГЭСН/ФЕР/ТЕР/ТСН",
        },
        {
          icon: img_catalog + "r-4.svg",
          icon_width: "24px",
          icon_height: "22px",
          text: "Автоматический подбор аналогов и предложений от поставщиков",
        },
        {
          icon: img_catalog + "r-6.svg",
          icon_width: "24px",
          icon_height: "22px",
          text: "Автоматическое формирование листа конъюнктурного анализа",
        },
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.block-head {
  padding: 65px 0 104px;

  @media screen and (max-width: $breakpoint-sm) {
    padding: 32px 0 52px;
  }

  .block-head__title {
    ::v-deep .text__inner {
      font-size: 50px;

      @media screen and (max-width: $breakpoint-sm) {
        font-size: 32px;
      }
    }
  }

  .block-head__button {
    height: auto;
    font-size: 18px;
    line-height: 1.44;
    padding: 21px 24px;
  }
}

.advantages {
  .advantages__item {
    margin-bottom: 24px;
    flex: 0 0 100%;

    @media screen and (max-width: $breakpoint-md) {
      &:last-child {
        margin-bottom: 0;
      }
    }

    @media screen and (min-width: $breakpoint-md) {
      flex: 0 0 47.5%;
      margin-right: 24px;
      &:nth-child(2n) {
        margin-right: 0;
      }
    }

    @media screen and (min-width: $breakpoint-lg) {
      flex: 0 0 47.4%;
      margin-right: 35px;
      &:nth-child(2n) {
        margin-right: 0;
      }
    }

    @media screen and (min-width: $breakpoint-xl) {
      flex: 0 0 28.3%;
      margin-right: 70px;
      &:nth-child(2n) {
        margin-right: 70px;
      }
      &:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}
</style>
